/**
 * Truncates a file path to be under maxLength characters by removing prefix directories
 * @param path - The full path to truncate
 * @param maxLength - Maximum length (default 40)
 * @returns Truncated path with "..." prefix if truncated
 */
export function truncatePath(path: string, maxLength: number = 40): string {
  if (!path || path.length <= maxLength) {
    return path;
  }
  
  // Split the path into parts
  const parts = path.split('/');
  
  // Start removing parts from the beginning until it fits
  let result = path;
  for (let i = 1; i < parts.length; i++) {
    const truncated = '.../' + parts.slice(i).join('/');
    if (truncated.length <= maxLength) {
      return truncated;
    }
  }
  
  // If even the last part is too long, just show it with ellipsis
  const lastPart = parts[parts.length - 1];
  if (lastPart.length > maxLength) {
    return '...' + lastPart.substring(lastPart.length - maxLength + 3);
  }
  
  return '.../' + lastPart;
}